import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { IProperty } from 'src/interfaces/Property';
import { getProperty } from 'src/services/PropertiesService';

export const useGetProperty = (propertyId: string): UseQueryResult<IProperty> => {
	return useQuery<IProperty>({
		queryKey: ['property', propertyId],
		queryFn: () => getProperty(propertyId),
		enabled: !!propertyId,
		staleTime: 60_000
	});
};
